import React from 'react';
import { useTranslation } from 'react-i18next';

export function WidgetPaymentMethod ({ text }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    return (<span style={{ padding: '0rem' }}>{formattedText }</span>);
}
